import React from "react";
import "./navbar.css";
import logo from "../../assets/logo/WhatsApp Image 2025-09-26 at 3.44.17 PM.jpeg";
import call from "../../assets/logo/call-answer-01.png";
import whatsapp from "../../assets/logo/whatspp.png";

function Navbar({ scrolled }) {
  const handleCall = () => {
    window.location.href = "tel:8778934301"; // opens phone dialer
  };

  return (
    <>
 
    <nav className={`navbar ${scrolled ? "scrolled" : "transparent"}`}>
      <div className="container-fluid">
        <div className="logo">
          <img
            src={logo}
     
            alt="Logo"
            className="logo-image"
          />
        </div>
        <button className="enquiry-btn" onClick={handleCall}>
          Get Enquiry
        </button>
      </div>
    </nav>
    
      <section>
          
                  <div className="main-icons">
                    <ul className="first">
                      <li className="color1">
                        <a href="tel:++918778934301">
                          <p>Call <br />+91 8778934301</p>
                          <img src={call} width="20px" height="20px" className="img-fluid" />
                        </a>
                      </li>
                      <li className="color2">
                        <a href="https://api.whatsapp.com/send?phone=918778934301" target="_blank">
                          <p>Whatsapp <br />+91 8778934301</p>
                          <img src={whatsapp} width="24" height="24" className="img-fluid" />
                        </a>
                      </li>
                      {/* <li className="color3">
                        <a
                          href="https://maps.app.goo.gl/W9jNi6VWGbfWmbB57"
                          target="_blank"
                          rel="noopener noreferrer" 
                        >
                          <p style={{ color: "black" }}>Location <br />First Sky Infra</p>
                          <img src={map} width="30" height="30" className="img-fluid1" alt="Map Icon" />
                        </a>
                      </li> */}
          
                    </ul>
                  </div>
                </section>

    </>
  );
}

export default Navbar;
